import axios from "axios";

export function deleteAccountFinaliseAPI(action) {
  const metaData = {
    withCredentials: true,
  };

  return new Promise((resolve) => {
    axios
      .post(
        `${process.env.REACT_APP_BACKEND}/delete_user/finalise`,
        {
          password: action.password,
          code: action.code,
        },
        metaData,
      )
      .then((response) => {
        resolve(response.data);
      })
      .catch((e) => {
        resolve(e.response.data);
      });
  });
}
